import brands from '@/brands/brands.js';


export function brandDetector() {


	var domain = location.host;


	var brandsIndex = {
		//PRO
		'tutor.uvaempleo.com': 'dotia',
		//PRE
		'tutores-uva.dev.doubledot.es': 'dotia',
		//LOCAL
		'localhost:8080': 'dotia'
	};

	var selected = brandsIndex[domain];
	console.log(selected)

	//SETEO DE LOS FAVICONS

	if (!!selected) {

		if (!!brands[selected].hasFavicon) {

			var url = '/static/img/brands/' + selected + '/favicon/';

			document.head.querySelector("[name=big-favicon]").href = url + 'apple-touch-icon.png';
			document.head.querySelector("[name=medium-favicon]").href = url + 'favicon-32x32.png';
			document.head.querySelector("[name=small-favicon]").href = url + 'favicon-16x16.png';
			document.head.querySelector("[name=favicon]").href = url + 'favicon.ico';
			document.head.querySelector("[name=msapplication-config]").href = url + 'browserconfig.xml';
			document.head.querySelector("[name=webmanifest]").href = url + 'site.webmanifest';

		}

		return brands[selected];


	} else {
		return brands['dotia'];
	}

}


// WEBPACK FOOTER //
// ./src/brands/index.js